const SCRIPT_ID = "konversa-widget";
const DEFAULT_WIDGET_URL = "https://app.konversa.com.ar/widget.js";
const DEFAULT_API_URL = "https://api.konversa.com.ar";
const DEFAULT_TENANT = "delplastic-demo";

// Solo acepta URLs https (o http://localhost para desarrollo).
function safeUrl(value, fallback) {
  const url = (value || "").trim();
  if (/^https:\/\/[^\s]+$/i.test(url) || /^http:\/\/localhost(:\d+)?(\/[^\s]*)?$/i.test(url)) {
    return url.replace(/\/+$/, "");
  }
  return fallback;
}

function widgetKey(env) {
  const key = (env.REACT_APP_KONVERSA_WIDGET_KEY || "").trim();
  return /^pk_[A-Za-z0-9_-]+$/.test(key) ? key : "";
}

// Widget de chat de Konversa. La clave publica (pk_...) llega por build-arg, asi que
// solo el build que la define (stage) lo carga: sin REACT_APP_KONVERSA_WIDGET_KEY no hace nada.
// Variables: REACT_APP_KONVERSA_WIDGET_KEY (obligatoria), REACT_APP_KONVERSA_WIDGET_URL,
// REACT_APP_KONVERSA_API_URL y REACT_APP_KONVERSA_TENANT (opcionales, con defaults).
export function loadKonversaWidget(env = process.env) {
  const key = widgetKey(env);
  if (!key) return false;
  if (document.getElementById(SCRIPT_ID)) return false;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = safeUrl(env.REACT_APP_KONVERSA_WIDGET_URL, DEFAULT_WIDGET_URL);
  script.setAttribute("data-key", key);
  // El widget llama a POST /api/chat/{tenant}: sin data-tenant usa "default" y da 404.
  const tenant = (env.REACT_APP_KONVERSA_TENANT || "").trim();
  script.setAttribute("data-tenant", /^[a-z0-9][a-z0-9-]*$/i.test(tenant) ? tenant : DEFAULT_TENANT);
  // El widget usa por defecto otro host: hay que indicarle donde esta la API de Konversa.
  script.setAttribute("data-base-url", safeUrl(env.REACT_APP_KONVERSA_API_URL, DEFAULT_API_URL));
  document.body.appendChild(script);
  return true;
}

// Ademas del build, el super_admin lo prende y lo apaga desde Configuracion
// (GET /config/chat-widget, apagado por defecto). Sin key en el build no se
// consulta nada; si la API falla o responde algo raro, el chat NO se carga.
export function loadKonversaWidgetSiHabilitado(env = process.env, fetchImpl = fetch) {
  if (!widgetKey(env)) return Promise.resolve(false);

  const apiBase = env.REACT_APP_API_URL || "http://localhost/api/public";
  return fetchImpl(`${apiBase}/config/chat-widget`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => (data && data.habilitado === true ? loadKonversaWidget(env) : false))
    .catch(() => false);
}
